<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<!-- <List :data-val="valData" @child-event='getListVal'></List>
		<a href="/static/export.xlsx" download="export" style="color: #FF0000; text-decoration: underline">下载导入模板</a> -->
		<Button class="submit-process" v-bind:disabled="isDisabled" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	// import List from '../components/List.vue';
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage
	} from '@/api/approval'
	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
		title: null,
		url: null,
		toUser: [],
		desc: null,
		template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
			// ,List
		},
		data() {
			return {
				isDisabled : false,
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				sendMessageData: Object.assign({}, sendMessagetTemplate),
				formLoading: false,
				listLoading: false,
				flowId:null,
				valData:{
					TotalCount: 0,
					listTitle:[{
							type: 'selection',
							width: 45,
							align: 'center',
							fixed: 'left'
						},
						{
							title: '资产编号',
							key: 'AssetsCode',
							width: 120,
							disabled: true
						}],
						listData: [],
						isDisabled: false
				}
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
		},
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values = [];
						dataVal.Value = depart.name;
						dataVal.Values.push([depart.id, depart.name]);
						getDepartmentInfo(depart.id).then(async response => {
							var departFullName = response.Body.FullName;
							var ApiDep = departFullName;
							var departName = departFullName.split("/");
							var department = res.result.departmentList[0];
							
							if (departName.indexOf("房友圈") == -1 &&
								departName.indexOf("工商铺商业运营中心") == -1 &&
								departName.indexOf("代理") == -1 &&
								departName.indexOf("二级市场营运中心") == -1 &&
								departName.indexOf("住宅部") == -1 &&
								departName.indexOf("藤云") == -1 
							) {
								that.Message({
									message: '该部门没有申请权限，请重新选择！',
									type: 'error',
									duration: 1000
								});
								that.isDisabled = true;
							}else{
								that.isDisabled = false;
							}
							
							
							that.templateData.TemplateContent.Controls.forEach(async (item, index) => {
								
								if (item.Property.Title[0].Text == "逐级审批") {
									item.Values = [];
									item.IsShow = false;
									if(departName.indexOf('住宅部')>-1||departName.indexOf('工商铺商业运营中心')>-1){
										item.Values=await that.getDepartmentRelationList(department.id,6);
									}else{
										item.Values=await that.getDepartmentRelationList(department.id,7);
									}
									if (item.Values == null || item.Values.length == 0) {
										item.Values = [
											["SC24000029", "钟志斌"]
										]
									}
									
								}
								
								if (item.Property.Title[0].Text == "大区董事") {
									item.Values=await that.getDepartmentRelation(department.id,"战区董事",true);
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
								if (item.Property.Title[0].Text == "大区总经理") {
									
									item.Values=await that.getDepartmentRelation(department.id,"董事总经理",true);
									
									if (item.Values == null || item.Values.length <= 0) {
										//审批节点无人，跳过
										item.Values.push(that.$store.state.defaultMember);
									}
								}
								
								
								if (item.Property.Title[0].Text == "所属部门") {
									if (departName.indexOf("联动拓展部") > -1||departName.indexOf("联动项目部")> -1|| departName.indexOf("后勤藤云") > -1 || departName.indexOf("事业部") > -1 || departName.indexOf("藤云拓展部") > -1) {
										item.Value = item.Config.Selector.Options
											.filter(item => {
												return item.Value[0].Text == "藤云";
											})[0].Key;
									} else if (departName.indexOf("住宅部") > -1) {
										item.Value = item.Config.Selector.Options
											.filter(item => {
												return item.Value[0].Text == "住宅部";
											})[0].Key;
									} else if (departName.indexOf("工商铺商业运营中心") > -1) {
										item.Value = item.Config.Selector.Options
											.filter(item => {
												return item.Value[0].Text == "工商铺";
											})[0].Key;
									} else if (departName.indexOf("二级市场营运中心") > -1||departName.indexOf("代理") > -1) {
										item.Value = item.Config.Selector.Options
											.filter(item => {
												return item.Value[0].Text == "二级市场";
											})[0].Key;
									} 
								}
							})
						});
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				var departName = this.logInfo.fullName.split("/");
				if (departName.indexOf("房友圈") == -1 &&
					departName.indexOf("工商铺商业运营中心") == -1 &&
					departName.indexOf("代理") == -1 &&
					departName.indexOf("二级市场营运中心") == -1 &&
					departName.indexOf("住宅部") == -1 &&
					departName.indexOf("藤云") == -1 
				) {
					that.Message({
						message: '没有申请权限！',
						type: 'error',
						duration: 1000
					});
					that.isDisabled = true;
				}
				
				await this.getEmployeeRelation();
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item, index) => {
						var departs = that.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "大区董事") {
							item.Values = []
							item.Values.push(that.$store.state.defaultMember);
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							item.Values = []
							item.Values.push(that.$store.state.defaultMember);
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "所属部门") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text === "拓展/事业总经理") {
							item.IsShow = false;
							item.Values = [["SC24000029", "钟志斌"]]
							if (departs.indexOf("事业部") > -1 || departs.indexOf("藤云拓展部") > -1){
								if (this.logInfo.PositionName !== "事业部总经理" && this.logInfo.PositionName !== "拓展部总经理"){
								const upperStratas = await this.getRelationList(this.relationList,7);
								item.Values = [upperStratas[upperStratas.length - 1]]
								}
							}
            			}
						if (item.Property.Title[0].Text == "逐级审批") {
							item.Values = [];
							item.IsShow = false;
							if(departName.indexOf('住宅部')>-1||departName.indexOf('工商铺商业运营中心')>-1){
								item.Values=that.getRelationList(that.relationList,6);
							}else{
								item.Values=that.getRelationList(that.relationList,7);
							}
							if (item.Values == null || item.Values.length == 0) {
								item.Values = [
									["SC24000029", "钟志斌"]
								]
							}
							
						}
						
						if (item.Property.Title[0].Text == "大区董事") {
							item.Values=that.findEmpByPositionName(that.relationList,"战区董事");
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
						}
						if (item.Property.Title[0].Text == "大区总经理") {
							
							item.Values=that.findEmpByPositionName(that.relationList,"董事总经理");
							
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(that.$store.state.defaultMember);
							}
						}
						
						
						if (item.Property.Title[0].Text == "所属部门") {
							if (departName.indexOf("联动拓展部") > -1||departName.indexOf("联动项目部")>-1|| departName.indexOf("后勤藤云") > -1 || departName.indexOf("藤云拓展部") > -1 || departName.indexOf("事业部") > -1) {
								item.Value = item.Config.Selector.Options
									.filter(item => {
										return item.Value[0].Text == "藤云";
									})[0].Key;
							} else if (departName.indexOf("住宅部") > -1) {
								item.Value = item.Config.Selector.Options
									.filter(item => {
										return item.Value[0].Text == "住宅部";
									})[0].Key;
							} else if (departName.indexOf("工商铺商业运营中心") > -1) {
								item.Value = item.Config.Selector.Options
									.filter(item => {
										return item.Value[0].Text == "工商铺";
									})[0].Key;
							} else if (departName.indexOf("二级市场营运中心") > -1||departName.indexOf("代理") > -1) {
								item.Value = item.Config.Selector.Options
									.filter(item => {
										return item.Value[0].Text == "二级市场";
									})[0].Key;
							} 
						}
						
					});
					that.templateData = that.assignControl(controls, that.logInfo);
					that.templateData = await that.assignControlBySpNo(controls, null, that.flowId);
					that.listLoading = false;
					
				});

			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if (name == "类别") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "维修" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "维修")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
			},
			getListVal: async function(data, type) {
				var that = this;
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				
				
				
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;

				
				
				
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "项目名称"})[0];
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合同中甲方名称"})[0];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"项目名称："+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control11=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "房企名称"})[0];
				var option = control11.Config.Selector.Options.filter(t =>{return t.Key == control11.Value;})[0];
				
				
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"房企名称："+option.Value[0].Text,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"合同中甲方名称："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				this.templateData.SummaryList=SummaryList;
				
				
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData, this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).error(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
